import { createFileRoute } from "@tanstack/react-router";
import { LocalLandingPage } from "@/components/landing/LocalLandingPage";
import { madridLandings } from "@/data/madrid-landings";
import { buildLocalLandingHead } from "@/lib/local-landing-seo";

const data = madridLandings["posicionamiento-web-madrid"]!;

export const Route = createFileRoute("/posicionamiento-web-madrid")({
  head: () => buildLocalLandingHead(data),
  component: () => <LocalLandingPage data={data} />,
});
